// Фасад над транспортом чата поддержки.
//
// Контракт (совпадает с протоколом бэкенда):
//   connect()                        -> Promise — подключение + auth
//   request(endpoint, payload)       -> Promise<payload> — auth | get_active_ticket | get_messages | send_message
//   on("message", fn)                -> unsubscribe — события с сервера
//
// Транспорт выбирается автоматически:
//   - задан REACT_APP_SUPPORT_WS -> реальный WebSocket (realSocket.js)
//   - иначе                      -> мок (mockSocket.js) для локальной разработки и тестов

import * as real from "./realSocket";
import * as mock from "./mockSocket";

export { TOKEN_KEY } from "./mockSocket";

const WS_URL = process.env.REACT_APP_SUPPORT_WS;
const transport = WS_URL ? real : mock;

if (typeof window !== "undefined" && !WS_URL) {
	console.warn("[support-chat] REACT_APP_SUPPORT_WS не задан — используется мок-транспорт");
}

export const connect = () => transport.connect();
export const request = (endpoint, payload) => transport.request(endpoint, payload);
export const on = (eventName, fn) => transport.on(eventName, fn);
